import { AtlasPricePromotionV2PageLayout } from 'src/components/AtlasV2Components/AtlasV2PageLayouts/AtlasPricePromotionV2PageLayout';
import { AtlasPriceSummaryV2PageLayout } from 'src/components/AtlasV2Components/AtlasV2PageLayouts/AtlasPriceSummaryV2PageLayout';
import GenericPageContainer from 'src/components/EntityPage/GenericPageContainer';

export default function getAtlasPriceV2PageLayout({ metricType }) {
  const salesPageLayout = {
    retailPrice: AtlasPriceSummaryV2PageLayout,
    promotions: AtlasPricePromotionV2PageLayout
  };

  return {
    CustomPageContainer: GenericPageContainer,
    enableComparison: false,
    widgets: [
      {
        name: 'AtlasPriceV2PageLayout',
        CustomComponent: salesPageLayout[metricType],
        view: {}
      }
    ],
    containerStyle: {},
    dataConfig: {}
  };
}
